import { __rest } from "tslib";
import { writable, derived } from 'svelte/store';
import { gql } from 'apollo-boost';
import { MyJSON } from '../utils';
import graphQLClient from '../graphql/client';
import { queryMe } from '../graphql/queries/users';
const LS_USER = 'USER_ITEM';
const userProfileQuery = gql(queryMe);
function createUserStore() {
    const { subscribe, set, update } = writable(MyJSON.parse(localStorage.getItem(LS_USER)));
    return {
        subscribe,
        refreshProfile: async () => {
            try {
                const { data } = await graphQLClient.client.query({ query: userProfileQuery });
                update((prevUserInfo) => {
                    const newUserInfo = Object.assign(Object.assign({}, prevUserInfo), { user: data.me });
                    localStorage.setItem(LS_USER, MyJSON.stringify(newUserInfo));
                    return newUserInfo;
                });
            }
            catch (err) {
                console.warn(`Error when refetching user profile:`, err);
            }
        },
        logIn: (userInfo) => {
            const { accessToken } = userInfo, rest = __rest(userInfo, ["accessToken"]);
            set(rest);
            localStorage.setItem(LS_USER, MyJSON.stringify(userInfo));
        },
        logOff: () => {
            set('');
            localStorage.setItem(LS_USER, '');
        }
    };
}
const userManager = createUserStore();
const isUserLogged = derived(userManager, ($user) => {
    if (!$user)
        return false;
    const expiration = new Date(parseInt(`${$user.accessExpiration}000`, 10));
    const now = new Date();
    return expiration > now;
});
const userInfo = derived(userManager, ($user) => (!!$user && $user.user) || {});
export { isUserLogged, userInfo, userManager };
